import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '../contexts/AuthContext';
import { apiRequest } from '../lib/api';

export type NoteRecord = {
  id: string;
  title: string;
  body: string;
  tags: string[];
  file_urls?: string[];
  file_names?: string[];
  file_types?: string[];
  file_sizes?: number[];
  appointment_id?: string | null;
  created_at: string | null;
  updated_at: string | null;
};

async function fetchNotes(
  clientId: string,
  accessToken: string | null | undefined,
) {
  return apiRequest<NoteRecord[]>(
    `/api/clients/${clientId}/notes`,
    { method: 'GET' },
    accessToken,
  );
}

export function useClientNotes(clientId: string) {
  const { session } = useAuth();

  return useQuery<NoteRecord[]>({
    queryKey: ['notes', clientId],
    enabled: Boolean(clientId && session),
    queryFn: () => fetchNotes(clientId, session?.access_token),
  });
}

export function useInvalidateNotes(clientId: string) {
  const queryClient = useQueryClient();
  return () =>
    queryClient.invalidateQueries({
      queryKey: ['notes', clientId],
    });
}
